var _g, _rect, _rect2, _rect3, _rect4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 144,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 125a5 5 0 0 1 5-5h72a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H44a5 5 0 0 1-5-5v-6Z",
    fill: "#fff",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 120.5h72a4.5 4.5 0 0 1 4.5 4.5v6a4.5 4.5 0 0 1-4.5 4.5H44a4.5 4.5 0 0 1-4.5-4.5v-6a4.5 4.5 0 0 1 4.5-4.5Z",
    stroke: "#fff",
    strokeOpacity: 0.1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 124,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#FACC15"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 124,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#2DD4BF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 124,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#63E7F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 124,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#93C5FD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 16a8 8 0 0 1 8-8h140a8 8 0 0 1 8 8v72a8 8 0 0 1-8 8H10a8 8 0 0 1-8-8V16Z",
    fill: "#0F172A"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8h1v69h-1V8Zm17 0h1v69h-1V8Zm18 0h-1v69h1V8Zm16 0h1v69h-1V8Zm18 0h-1v69h1V8Zm16 0h1v69h-1V8Zm18 0h-1v69h1V8Zm16 0h1v69h-1V8Zm18 0h-1v69h1V8Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158 18H2v1h156v-1Zm0 17H2v1h156v-1ZM2 52h156v1H2v-1Zm156 17H2v1h156v-1Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 85,
    width: 80,
    height: 2,
    rx: 1,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78 88a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-37-3a1 1 0 1 0 0 2h32a1 1 0 1 0 0-2H41Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.005 60.172 1.096-13.589c.127-1.583 2.415-2.163 3.469-.88l9.055 11.035c1.067 1.3-.308 3.066-2.059 2.643l-4.054-.98c-.748-.18-1.545.055-2.021.597l-2.054 2.34c-1.165 1.328-3.567.512-3.431-1.166Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 44v-5a4 4 0 0 0-4-4H67a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h13.5",
    stroke: "#94A3B8",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 29,
    y: 110,
    width: 102,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_33_1225"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_33_1225",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: -13,
    y: 1,
    width: 186,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_1225"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_33_1225",
    result: "effect2_dropShadow_33_1225"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_33_1225",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 8)",
    d: "M0 0h156v88H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/video-player.1714da939a238838abe81a76557b0c20.svg";
export { ForwardRef as ReactComponent };